module.exports = __webpack_public_path__ + "static/media/point+1.5af2c075.png";